export default __webpack_public_path__ + "static/media/html.b5ced9f9.jpg";